module.exports = __webpack_public_path__ + "img/burger-flowers.6898ff65.jpg";